/**
 * User Group
 */
export interface IUserGroupModel {
    id: number,
    title: string,
    allowed_categories: number[],
    allow_all: boolean,
}

export const EmptyUserGroup: IUserGroupModel = {
    id: 0,
    title: "",
    allowed_categories: [],
    allow_all: false,
}